import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'state/modules/popup';
import Modal from 'react-modal';
import { PopupAttemptContact } from 'components';
import translate from 'i18n/translate';
import { PopupNoSale, PopupEdit, PopupSale, PopupAppointment, PopupAdd } from 'containers';
import _ from 'lodash';
import styles from './Popup.css';

const debug = _debug('app:Popup');
class Popup extends Component {
  static propTypes = {
    closePopup: React.PropTypes.func,
    clickedIndex: React.PropTypes.number,
    textLabel: React.PropTypes.string,
    popupType: React.PropTypes.number,
    wholeData: React.PropTypes.objectOf(React.PropTypes.shape({})),
    contactData: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    insertContactData: React.PropTypes.func,
    fetchContactData: React.PropTypes.func,
    updateContactData: React.PropTypes.func,
    saveEventToCalendar: React.PropTypes.func,
    refreshTable: React.PropTypes.func,
    strings: React.PropTypes.shape({}),
    currentLanguage: React.PropTypes.string,
    updateToMiscData: React.PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      attempts: '',
      value: '',
      radioValue: '0',
      editDropdownValue: '0',
      commentValue: '',
      name: '',
      location: ''
    };
  }

  componentWillMount() {
    if ((this.props.popupType !== 4) && (this.props.popupType !== 2) &&
      (this.props.popupType !== 3) && (this.props.popupType !== 6)) {
      const promised = this.props.fetchContactData(this.props.wholeData.id);
      promised.then((response) => {
        if (!isNaN(parseInt(response.cica_attemptedcontactnumber, 10))) {
          this.setState({ attempts: response.cica_attemptedcontactnumber });
        } else {
          this.setState({ attempts: '0' });
        }
        if (!isNaN(parseInt(response.cica_reasoncode, 10))) {
          this.setState({ value: response.cica_reasoncode });
        } else {
          this.setState({ value: '1' });
        }
        if (!isNaN(parseInt(response.cica_reasontext, 10))) {
          this.setState({ radioValue: '1' });
        } else {
          this.setState({ radioValue: '0' });
        }
        if (response.lastname) {
          this.setState({ name: response.lastname });
        }
        if (response.cica_calltype !== '' && response.cica_calltype !== undefined) {
          if (response.cica_calltype === '2') {
            this.setState({ address: `${response.address1_line1 ? response.address1_line1 : ''} ${response.address1_city ? response.address1_city : ''} ${response.address1_stateorprovince ? response.address1_stateorprovince : ''} ${response.address1_postalcode ? response.address1_postalcode : ''}` });
          } else if (response.cica_calltype === '1') {
            this.setState({ address: `${response.address2_line1 ? response.address2_line1 : ''} ${response.address2_city ? response.address2_city : ''} ${response.address2_stateorprovince ? response.address2_stateorprovince : ''} ${response.address2_postalcode ? response.address2_postalcode : ''}` });
          }
        }
      }, errorResponse => debug(errorResponse));
    }
  }

  openModal = () => {
    this.setState({ open: true });
  }

  closeModal = () => {
    this.setState({ open: false });
    this.props.closePopup();
  }

  editRadioChange = (value) => {
    this.setState({ editRadioValue: value });
  }

  handleEditDropdownChange = (value) => {
    this.setState({ editDropdownValue: value });
  };

  reduceNumber = () => {
    if (parseInt(this.state.attempts, 10) > 0) {
      const attempts = (parseInt(this.state.attempts, 10) - 1).toString();
      this.setState({ attempts });
    }
  };

  increaseNumber = () => {
    if (parseInt(this.state.attempts, 10) < 5) {
      const attempts = (parseInt(this.state.attempts, 10) + 1).toString();
      this.setState({ attempts });
    }
  }
  locationAction = (address) => {
    this.setState({ address });
  }
  titleAction = (name) => {
    this.setState({ name });
  }
  updateContactData = (type) => {
    let closeCarouselFlag = false;
    const contactData = this.props.contactData;
    if (type === 'attempted_contact') {
      contactData.cica_attemptedcontactnumber = this.state.attempts;
      contactData.cica_leaddispositionstatus = '2';
      contactData.isappointmentterminated = false;
      closeCarouselFlag = true;
    } else if (type === 'no_sale') {
      contactData.cica_reasoncode = this.state.value;
      if (this.state.radioValue) {
        contactData.cica_reasontext = this.state.commentValue;
      }
      closeCarouselFlag = true;
      contactData.cica_leaddispositionstatus = '5';
      contactData.isappointmentterminated = false;
    }
    this.props.updateContactData(contactData).then(() => {
      this.props.refreshTable(closeCarouselFlag);
    }, errorResponse => debug(errorResponse));
    this.closeModal();
  }

  saveEventToCalendar = (eventData, contactData) => {
    this.props.saveEventToCalendar(eventData, contactData);
    this.props.updateContactData(contactData).then(() => {
      this.props.refreshTable(false);
    }, errorResponse => debug(errorResponse));
    this.closeModal();
  }

  insertContactData = (contactData) => {
    this.props.insertContactData(contactData).catch(error => debug(error));
    this.closeModal();
  }

  updateLeadContact = (contactData) => {
    this.props.updateContactData(contactData).then(() => {
      // this.props.refreshTable();
    }, errorResponse => debug(errorResponse));
    this.closeModal();
  }

  renderPopup = () => {
    if (this.props.popupType === 1) {
      return (
        <PopupAttemptContact
          increaseNumber={this.increaseNumber}
          date={this.state.attempts}
          reduceNumber={this.reduceNumber}
          save={this.updateContactData}
          refreshTable={this.props.refreshTable}
          strings={this.props.strings}
          currentLanguage={this.props.currentLanguage}
        />
      );
    } else if (this.props.popupType === 2) {
      return (
        <PopupNoSale
          closeModal={this.closeModal}
          dataId={this.props.wholeData.id}
          refreshTable={this.props.refreshTable}
          wholeData={this.props.wholeData}
          strings={this.props.strings}
          currentLanguage={this.props.currentLanguage}
        />
      );
    } else if (this.props.popupType === 3) {
      return (
        <PopupSale
          closeModal={this.closeModal}
          dataId={this.props.wholeData.id}
          refreshTable={this.props.refreshTable}
          strings={this.props.strings}
          currentLanguage={this.props.currentLanguage}
        />
      );
    } else if (this.props.popupType === 6) {
      return (
        <PopupEdit
          editDropdownValue={this.state.editDropdownValue}
          handleEditDropdownChange={this.handleEditDropdownChange}
          editRadioValue={this.state.editRadioValue}
          editRadioChange={this.editRadioChange}
          closeAction={this.props.closePopup}
          saveContactAction={this.insertContactData}
          updateContactAction={this.updateLeadContact}
          popupType={this.props.popupType}
          wholeData={this.props.wholeData}
          strings={this.props.strings}
          currentLanguage={this.props.currentLanguage}
        />
      );
    } else if (this.props.popupType === 4) {
      return (
        <PopupAdd
          closeAction={this.props.closePopup}
          saveContactAction={this.insertContactData}
          strings={this.props.strings}
          currentLanguage={this.props.currentLanguage}
        />
      );
    } else if (this.props.popupType === 5) {
      return (
        <PopupAppointment
          closeAction={this.props.closePopup}
          saveEventAction={this.saveEventToCalendar}
          name={this.state.name}
          address={this.state.address}
          locationAction={this.locationAction}
          titleAction={this.titleAction}
          contactData={this.props.contactData}
          strings={this.props.strings}
          refreshTable={this.props.refreshTable}
          currentLanguage={this.props.currentLanguage}
          wholeData={this.props.wholeData}
          updateToMiscData={this.props.updateToMiscData}
        />
      );
    }
    return (
      <div className={styles.popupBody} />
    );
  };

  render() {
    let popupType = styles.popup;
    if (this.props.popupType === 4) {
      popupType = styles.popupBig;
    } else if (this.props.popupType === 6) {
      popupType = styles.popupVeryBig;
    } else if (this.props.popupType === 5) {
      popupType = styles.popupLarger;
    } else if ((this.props.popupType === 3) || (this.props.popupType === 2)) {
      popupType = styles.popupWideAndLarge;
    } else if (this.state.radioValue === '1') {
      popupType = styles.popupLarge;
    }
    return (
      <Modal
        isOpen={this.state.open}
        className="modalClass"
        overlayClassName="overlayClass"
      >
        <div className={styles.popupcontainer}>
          <div className={popupType}>
            <div
              className={
              (_.indexOf([6, 4], this.props.popupType) !== -1) ?
              styles.popupHeaderBig : styles.popupHeader}
            >
              <div className={styles.popupHeaderDiv}>
                <span
                  className={(this.props.popupType === 4 || this.props.popupType === 5
                    || this.props.popupType === 6) ?
                    styles.popupHeaderBigLabel : styles.popupHeaderLabel}
                >
                  {this.props.textLabel}
                </span>
              </div>
              {
                (_.indexOf([4, 5, 6], this.props.popupType) !== -1)
                  ? null : <div className={styles.headerClose}>
                    <input
                      type="image"
                      src="static/popup_close_btn.png"
                      alt="Close"
                      className={styles.closeButton}
                      onMouseDown={() => this.props.closePopup(this.props.clickedIndex)}
                    />
                  </div>
              }
            </div>
            {this.renderPopup()}
          </div>
        </div>
      </Modal>
    );
  }
}
const mapStateToProps = state => ({
  contactData: state.popup.contactData,
  fetchContactData: state.popup.fetchContactData,
  updateContactData: state.popup.updateContactData,
  insertContactData: state.popup.insertContactData,
  currentLanguage: state.manage.currentLanguage
});


const PopupString = translate('Popup')(Popup);
export default connect(mapStateToProps, actions)(PopupString);



// WEBPACK FOOTER //
// ./src/containers/Popup/Popup.js